// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z8Ag7","rootMobile":"styles_rootMobile__3G5gg"};